// extracted by mini-css-extract-plugin
export default {"animationContainer":"styles_animationContainer__U5FoI","loaderElement":"styles_loaderElement__j5VFP"};